// /messages (unified chat) — /inbox/* routes are pure redirects with no UI text.
export const inbox: Record<string, string> = {
  'Group': 'Grupa',
  'Group name': 'Naziv grupe',
  'Follow some traders first — you can add anyone you follow.': 'Prvo zaprati neke trejdere — možeš dodati svakoga koga pratiš.',
  'Create group': 'Napravi grupu',
  "No chats yet. Open a trader's profile and hit Message, or start a group.": 'Još nema ćaskanja. Otvori profil trejdera i klikni Pošalji poruku, ili napravi grupu.',
  'Message request · ': 'Zahtev za poruku · ',
  'Request sent · ': 'Zahtev poslat · ',
  'chart': 'grafikon',
  'members': 'članova',
  'Say hi': 'Pozdravi se',
  'Select a conversation': 'Izaberi razgovor',
  'Message request': 'Zahtev za poruku',
  'Request pending': 'Zahtev na čekanju',
  'Direct message': 'Direktna poruka',
  'wants to message you. Accept to start chatting.': 'želi da ti pošalje poruku. Prihvati da počnete ćaskanje.',
  'Accept': 'Prihvati',
  'Decline': 'Odbij',
  'Decline & block': 'Odbij i blokiraj',
  'Request sent —': 'Zahtev poslat —',
  'needs to accept before this becomes a regular chat.': 'treba da prihvati pre nego što ovo postane običan razgovor.',
  'Decline and block this trader?': 'Odbiti i blokirati ovog trejdera?',
  'Decline this request? The conversation will be deleted.': 'Odbiti ovaj zahtev? Razgovor će biti obrisan.',
  'Leave this group?': 'Napustiti ovu grupu?',
  'Could not create the group.': 'Nije moguće napraviti grupu.',
  'Everyone you follow is already in this group.': 'Svi koje pratiš su već u ovoj grupi.',
  'Add members — type usernames separated by commas:': 'Dodaj članove — ukucaj korisnička imena odvojena zarezima:',
  'Could not add members.': 'Nije moguće dodati članove.',
  'Could not accept the request.': 'Nije moguće prihvatiti zahtev.',
  'Could not decline the request.': 'Nije moguće odbiti zahtev.',
  'Could not leave the group.': 'Nije moguće napustiti grupu.',
  'Say hi to': 'Pozdravi',
  'This conversation is private.': 'Ovaj razgovor je privatan.',
  'Only members can see this group.': 'Samo članovi vide ovu grupu.',
  'Add members': 'Dodaj članove',
  'Leave group': 'Napusti grupu',
};
